export default function ValidateUgyfelszam(values: any) {
    let errors:any = {};
    
    if (!values.ugyfelszam) {
        errors.ugyfelszam = 'A "Partner azonosító" mező kötelező!';
    }

    return errors;
}
